import React, { Component, useEffect } from "react";
import * as stdActions from "../../redux/actions/stdAction";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar";
import { setLanguage } from "redux-i18n";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as accomodationActions from "../../redux/actions/accomodationAction";
import * as attachmentsActions from "../../redux/actions/attachmentsAction";
import ErsApplicantComponent from "../../components/ErsApplicant";
import { initialPagination, ersInitialPagination } from "../../App.config";
import AccomodationApplicantTemplete from "../../components/AccomodationApplicant";

const AccomodationApplicant = (props, context) => {
  const accomodationReducer = useSelector((state) => state.accomodationReducer);
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const i18nReducer = useSelector((state) => state.i18nState);
  
  const dispatch = useDispatch();
  let accomodationAction = bindActionCreators(accomodationActions, dispatch);
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);
  
  ///Set initial pagination and call api after first render
  useEffect(() => {
    accomodationAction.setCurrentPage(initialPagination.pageNo);
    accomodationAction.setPageSize(initialPagination.pageSize);
    accomodationAction.getAccomodationApplicants(initialPagination, null, profileReducer);
    return () => {
      accomodationAction.setCurrentPage(initialPagination.pageNo);
      accomodationAction.setPageSize(initialPagination.pageSize);
    };
  }, []);

  const searchByName = (name) => {
    accomodationAction.getAccomodationApplicants(initialPagination, name, profileReducer);
    accomodationAction.setCurrentPage(initialPagination.pageNo);
    accomodationAction.setPageSize(initialPagination.pageSize);
  };

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };

  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  const openSetModal = (children) => {
    modalAction.openSetModal(children);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const setFilteredApplicants = (filteredApplicants) => {
    //accomodationAction.setFilteredApplicants(filteredApplicants);
  };

  const onChange = (page) => {
    accomodationAction.setCurrentPage(page.value);
    accomodationAction.getAccomodationApplicants(
      {
        pageNo: page.value,
        pageSize: accomodationReducer.pageSize,
        totalRows: accomodationReducer.totalRows,
      },
      page.searchKey,
      profileReducer
    );
  };

  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}
      <div className="Content-Panel">
        <AccomodationApplicantTemplete
          setFilteredApplicants={setFilteredApplicants}
          applicants={accomodationReducer.applicants}
          filteredApplicants={accomodationReducer.applicants}
          currentPage={accomodationReducer.currentPage}
          pageSize={accomodationReducer.pageSize}
          totalRows={accomodationReducer.totalRows}
          searchByName={searchByName}
          openSetModal={openSetModal}
          closeRemoveModal={closeRemoveModal}
          // onPageSizeChange={onPageSizeChange}
          onChange={(props) => {
            onChange(props);
          }}
        />
      </div>
    </>
  );
};

AccomodationApplicant.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default AccomodationApplicant;
